import { createAsyncThunk } from '@reduxjs/toolkit'
import HeaderCompanyAnalysisService from './services/HeaderCompanyAnalysisService'

export const getHeaderCompanyAnalysis = createAsyncThunk(
  'companyAnalysis/header/getCompanyInfo',
  async (params, { rejectWithValue }) => {
    try {
      const res = await HeaderCompanyAnalysisService.getHeaderCompanyAnalysis(
        params,
      )

      return res.success ? res.data : rejectWithValue(res.errors)
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)

export const getScoreRangesCreditRisk = createAsyncThunk(
  'companyAnalysis/header/getScoreRangesCreditRisk',
  async (params, { rejectWithValue }) => {
    try {
      const res = await HeaderCompanyAnalysisService.getScoreRangesCreditRisk(
        params,
      )
      return res.success ? res.data : rejectWithValue(res.errors)
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)

export const getScoreRangesPerformance = createAsyncThunk(
  'companyAnalysis/header/getScoreRangesPerformance',
  async (params, { rejectWithValue }) => {
    try {
      const res = await HeaderCompanyAnalysisService.getScoreRangesPerformance(
        params,
      )
      return res.success ? res.data : rejectWithValue(res.errors)
    } catch (err) {
      return rejectWithValue(err)
    }
  },
)
